import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MapPinIcon, ClockIcon, DollarSignIcon, TrendingUpIcon, BellIcon, SettingsIcon } from 'lucide-react';
import { BottomNav } from '../components/BottomNav';
import { Button } from '../components/Button';
import { DriverToggle } from '../components/DriverToggle';
import { useApp } from '../context/AppContext';
export const DriverHome: React.FC = () => {
  const navigate = useNavigate();
  const {
    user
  } = useApp();
  const [isOnline, setIsOnline] = useState(false);
  const availableRides = [{
    id: '1',
    pickup: 'JB Sentral',
    dropoff: 'Orchard Road',
    type: 'Premium',
    fare: 120,
    currency: 'RM',
    distance: '45 km',
    time: '15 min away'
  }, {
    id: '2',
    pickup: 'Taman Molek',
    dropoff: 'Changi Airport T3',
    type: 'Airport',
    fare: 150,
    currency: 'RM',
    distance: '55 km',
    time: '8 min away',
    flightTime: '2:30 PM'
  }, {
    id: '3',
    pickup: 'Bukit Indah',
    dropoff: 'Marina Bay',
    type: 'Standard',
    fare: 85,
    currency: 'RM',
    distance: '42 km',
    time: '20 min away'
  }];
  const todayStats = {
    trips: 5,
    earnings: 425,
    hours: 6.5,
    rating: 4.9
  };
  return <div className="min-h-screen bg-background pb-16" data-id="element-304">
      <div className="p-6" data-id="element-305">
        <div className="flex items-center justify-between mb-6" data-id="element-306">
          <div data-id="element-307">
            <h1 className="text-2xl font-semibold" data-id="element-308">
              {isOnline ? 'Online' : 'Offline'}
            </h1>
            <p className="text-white text-opacity-70" data-id="element-309">
              {isOnline ? 'Ready for rides' : 'Go online to accept rides'}
            </p>
          </div>
          <div className="flex items-center space-x-3" data-id="element-310">
            <button className="bg-card p-2 rounded-full" data-id="element-311">
              <BellIcon size={20} className="text-primary" data-id="element-312" />
            </button>
            <DriverToggle data-id="element-313" />
          </div>
        </div>
        <div className="mb-8" data-id="element-314">
          <Button onClick={() => setIsOnline(!isOnline)} className={`${isOnline ? 'bg-red-500 hover:bg-red-600' : ''}`} data-id="element-315">
            {isOnline ? 'Go Offline' : 'Go Online'}
          </Button>
        </div>
        {isOnline && <>
            <div className="grid grid-cols-2 gap-3 mb-8" data-id="element-316">
              <div className="card" data-id="element-317">
                <div className="flex items-center mb-2" data-id="element-318">
                  <DollarSignIcon size={16} className="text-primary mr-2" data-id="element-319" />
                  <span className="text-sm text-white text-opacity-70" data-id="element-320">
                    Today
                  </span>
                </div>
                <p className="text-2xl font-bold text-primary" data-id="element-321">
                  RM {todayStats.earnings}
                </p>
                <p className="text-xs text-white text-opacity-70 mt-1" data-id="element-322">
                  {todayStats.trips} trips • {todayStats.hours}h
                </p>
              </div>
              <div className="card" data-id="element-323">
                <div className="flex items-center mb-2" data-id="element-324">
                  <TrendingUpIcon size={16} className="text-primary mr-2" data-id="element-325" />
                  <span className="text-sm text-white text-opacity-70" data-id="element-326">
                    Rating
                  </span>
                </div>
                <p className="text-2xl font-bold text-primary" data-id="element-327">
                  {todayStats.rating}
                </p>
                <p className="text-xs text-white text-opacity-70 mt-1" data-id="element-328">
                  Last 100 trips
                </p>
              </div>
            </div>
            <div className="mb-6" data-id="element-329">
              <h2 className="text-lg font-medium mb-4" data-id="element-330">Available Rides</h2>
              <div className="space-y-3" data-id="element-331">
                {availableRides.map(ride => <div key={ride.id} className="card" onClick={() => navigate('/driver/ride-request', {
              state: ride
            })} data-id="element-332">
                    <div className="flex items-center justify-between mb-3" data-id="element-333">
                      <div className="chip" data-id="element-334">{ride.type}</div>
                      <div className="text-primary font-bold text-lg" data-id="element-335">
                        {ride.currency} {ride.fare}
                      </div>
                    </div>
                    <div className="flex items-start mb-2" data-id="element-336">
                      <MapPinIcon size={16} className="text-primary mt-1 mr-2 flex-shrink-0" data-id="element-337" />
                      <div data-id="element-338">
                        <p className="text-sm text-white text-opacity-70" data-id="element-339">
                          Pickup
                        </p>
                        <p className="font-medium" data-id="element-340">{ride.pickup}</p>
                      </div>
                    </div>
                    <div className="flex items-start mb-3" data-id="element-341">
                      <MapPinIcon size={16} className="text-primary mt-1 mr-2 flex-shrink-0" data-id="element-342" />
                      <div data-id="element-343">
                        <p className="text-sm text-white text-opacity-70" data-id="element-344">
                          Dropoff
                        </p>
                        <p className="font-medium" data-id="element-345">{ride.dropoff}</p>
                        {ride.flightTime && <p className="text-xs text-primary mt-1" data-id="element-346">
                            Flight: {ride.flightTime}
                          </p>}
                      </div>
                    </div>
                    <div className="flex items-center justify-between text-sm" data-id="element-347">
                      <span className="text-white text-opacity-70" data-id="element-348">
                        {ride.distance}
                      </span>
                      <span className="text-primary" data-id="element-349">{ride.time}</span>
                    </div>
                  </div>)}
              </div>
            </div>
          </>}
        {!isOnline && <div className="text-center py-12" data-id="element-350">
            <div className="w-16 h-16 bg-card rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-351">
              <ClockIcon size={32} className="text-white text-opacity-50" data-id="element-352" />
            </div>
            <p className="text-white text-opacity-70" data-id="element-353">
              Go online to start accepting rides
            </p>
          </div>}
      </div>
      <BottomNav data-id="element-354" />
    </div>;
};